/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */
import { IconBox, SVGIcon } from "@nordcloud/gnui";
import { CloudProviderType, Provider } from "~/generated/graphql";
import { getProviderIconName } from "~/tools";

type AccountTypeIconProps = {
  provider?: Provider;
  providerType?: CloudProviderType;
};

export const getIconName = (
  provider?: Provider,
  provideType?: CloudProviderType
) => {
  if (!provider) {
    return "statusError";
  }
  return getProviderIconName(provider, provideType);
};

function AccountTypeIcon(props: AccountTypeIconProps) {
  return (
    <IconBox>
      <SVGIcon name={getIconName(props.provider, props.providerType)} />
    </IconBox>
  );
}

export default AccountTypeIcon;
